import cn from 'classnames';
import PropTypes from 'prop-types';

import ShippingDowngradeDetails from 'components/checkout/melody/shippingOption/ShippingDowngradeDetails';
import { SmallLoader } from 'components/Loader';
import { formatShippingPrice } from 'helpers/CheckoutUtils';
import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/melody/shipoption/shipOptionList.scss';

const ShippingOptionList = (params, { testId = f => f }) => {
  const {
    isAssignedExposeShipOptions,
    isEligibleForShippingDowngrade,
    onSelectAndUseShippingOptionClick,
    onSelectShippingOptionClick,
    onUseShippingOptionClick,
    purchaseDataIsLoading,
    selectedShippingOptionId,
    shipOptionsLoaded,
    shipOptionsLoading,
    shippingDowngrade,
    shippingOptions
  } = params;

  const hasSavedShippingOptions = !!shippingOptions?.length;

  if (shipOptionsLoaded && !shipOptionsLoading && !hasSavedShippingOptions) {
    return <div className={css.noShippingOptions}><p>Sorry, no shipping options are available at this time.</p></div>;
  }

  if (!hasSavedShippingOptions) {
    return <SmallLoader />;
  }

  return (
    <form
      className={cn(css.wrapper, { [css.eso]: isAssignedExposeShipOptions })}
      data-test-id={testId('shippingOptionListSection')}
      method="POST"
      action="/marty/mcheckout/shipoption">
      {
        hasSavedShippingOptions && shippingOptions.map(option => makeItemRow({ isAssignedExposeShipOptions, isEligibleForShippingDowngrade, purchaseDataIsLoading, onSelectAndUseShippingOptionClick, onSelectShippingOptionClick, onUseShippingOptionClick, option, selectedShippingOptionId, shippingDowngrade, testId }))
      }
    </form>
  );
};

const makeItemRow = ({ isAssignedExposeShipOptions, isEligibleForShippingDowngrade, purchaseDataIsLoading, onSelectAndUseShippingOptionClick, onSelectShippingOptionClick, onUseShippingOptionClick, option, selectedShippingOptionId, shippingDowngrade, testId }) => {
  const { name: shipmentSpeed, promise, id: shippingOptionId, price: shippingCharge } = option;
  const isSelected = shippingOptionId === selectedShippingOptionId || selectedShippingOptionId === shipmentSpeed;
  const itemStyles = cn(css.item, { [css.selected]: isSelected });
  const esoItemStyles = cn(css.item, css.eso, { [css.selected]: isSelected });

  const { points, dollar_value: dollarValue } = shippingDowngrade?.[shipmentSpeed] || { points: null, dollar_value: null };

  if (isAssignedExposeShipOptions) {
    return (
      <div className={esoItemStyles} key={shippingOptionId}>
        <div className={css.row}>
          <div className={css.selectionBlock}>
            <input
              checked={isSelected}
              data-shipping-option-id={shippingOptionId}
              disabled={purchaseDataIsLoading}
              onChange={onSelectAndUseShippingOptionClick}
              type="radio"
              id={`shipOption-${shippingOptionId}`}
              name="shippingOptionList"
              data-test-id={testId('shipOptionInput')} />
            <label className={css.optionLabel} htmlFor={`shipOption-${shippingOptionId}`} data-test-id={testId('innerShipOptionLabel')}>
              {promise} { formatShippingPrice(shippingCharge) }
            </label>
          </div>
        </div>
      </div>
    );
  }

  return (
    <label htmlFor={`shipOption-${shippingOptionId}`} key={shippingOptionId} data-test-id={testId('outerShipOptionLabel')}>
      <div className={itemStyles}>
        <div className={css.row}>
          <div className={css.selectionBlock}>
            <div>
              <input
                checked={isSelected}
                data-shipping-option-id={shippingOptionId}
                disabled={purchaseDataIsLoading}
                onClick={onSelectShippingOptionClick}
                onChange={onSelectShippingOptionClick}
                type="radio"
                id={`shipOption-${shippingOptionId}`}
                name="shippingOptionList"
                data-test-id={testId('shipOptionInput')} />
              <label htmlFor={`shipOption-${shippingOptionId}`} data-test-id={testId('innerShipOptionLabel')}>{promise} { formatShippingPrice(shippingCharge) }</label>
              {
                isEligibleForShippingDowngrade && shipmentSpeed === 'next-wow' && !!points && <ShippingDowngradeDetails
                  downgradeEstimateDollars={dollarValue}
                  downgradeEstimatePoints={points}
                  promise={promise}
                  title={`Get ${toUSD(dollarValue)} in Zappos Rewards Points.`} />
              }
            </div>
          </div>
          <div>
            {
              isSelected && <button
                type="button"
                className={css.useShipOptionBtn}
                data-test-id={testId('useShippingOptionBtn')}
                disabled={purchaseDataIsLoading}
                onClick={onUseShippingOptionClick}>
                { purchaseDataIsLoading ? 'Submitting...' : 'Use this shipping speed' }
              </button>
            }
          </div>
        </div>
      </div>
    </label>
  );
};

ShippingOptionList.contextTypes = {
  testId: PropTypes.func
};

export default ShippingOptionList;
